import { EntityBuilder } from '../../../../../apps/idl/src/services/security/EntityBuilder';
import { ISecurityConfig } from '../../../../../apps/idl/src/services/security/security/ISecurityConfig';
import { IAppInfo } from '../../../../../apps/idl/src/model/application/IAppInfo';
import { IEnvironment } from '../environment/IEnvironment';
import { IAuthentication } from '../IAuthentication';
import { IUpdateConfig } from '../update';
import { IBackgroundTask } from 'apps/idl/src/model/backgroundTask';

export interface IConfig {

	/** Informations de l'application. */
	appInfo: IAppInfo;
	/** Chaînes de connexion aux serveurs. */
	environment: IEnvironment;
	/** Informations sur l'authentification. */
	authentication: IAuthentication;
	/** Informations sur les background tasks. */
	backgroundTask: IBackgroundTask;
	/** Générateurs d'entités. */
	entityBuilders: EntityBuilder[];
	/** Paramètres de mise à jour */
	update: IUpdateConfig;
	/** Identifiant du groupe d'utitilisateurs administrateurs */
	security?: ISecurityConfig;
}